import {
  AmExCardIcon,
  CreditCardIcon,
  DiscoverCardIcon,
  MasterCardIcon,
  NeimanMarcusCardIcon,
  BergdorfGoodmanCardIcon,
  VisaCardIcon,
  CashPaymentIcon,
  CheckPaymentIcon,
  GiftPaymentIcon,
  DinersClubCardIcon,
  JCBCardIcon,
} from 'sharedComponents/Icons';

const CFA_CARD_TYPES = {
  VIC: 'Visa',
  MCC: 'MasterCard',
  AXC: 'American Express',
  DCC: "Diners' Club",
  NVC: 'Discover',
  JBC: 'JCB',
  NM: 'Neiman Marcus',
  BG: 'Bergdorf Goodman',
  PPC: 'PayPal',
  CUP: 'China UnionPay',
};

const SHORT_CARD_TYPES = {
  VISA: 'VIC',
  MASTERCARD: 'MCC',
  'AMERICAN EXPRESS': 'AXC',
  "DINERS' CLUB": 'DCC',
  DISCOVER: 'NVC',
  JCB: 'JBC',
  'NEIMAN MARCUS': 'PLC',
  'BERGDORF GOODMAN': 'PLC',
  PAYPAL: 'PPC',
  'CHINA UNIONPAY': 'CUP',
  BG: 'PLC',
  NM: 'PLC',
};

export const getCardIconByCardType = (cardType = '') => {
  if (cardType.toUpperCase().startsWith('GC')) {
    return GiftPaymentIcon;
  }
  if (cardType.toUpperCase().startsWith('NM')) {
    return NeimanMarcusCardIcon;
  }
  if (cardType.toUpperCase().startsWith('BG')) {
    return BergdorfGoodmanCardIcon;
  }

  switch (cardType.toUpperCase()) {
    case 'VISA':
    case 'VIC':
      return VisaCardIcon;

    case 'MASTERCARD':
    case 'MCC':
    case 'MC':
      return MasterCardIcon;

    case 'CHG':
    case 'PLC':
    case 'PLCC':
    case CFA_CARD_TYPES.NM.toUpperCase():
      return NeimanMarcusCardIcon;

    case CFA_CARD_TYPES.JBC:
    case SHORT_CARD_TYPES.JCB:
      return JCBCardIcon;

    case CFA_CARD_TYPES.DCC.toUpperCase():
    case SHORT_CARD_TYPES["DINNERS' CLUB"]:
    case 'DCC':
      return DinersClubCardIcon;

    case CFA_CARD_TYPES.BG.toUpperCase():
      return BergdorfGoodmanCardIcon;

    case 'DISCOVER':
    case 'NVC':
    case 'DISC':
      return DiscoverCardIcon;

    case 'AMERICAN EXPRESS':
    case 'AXC':
    case 'AMEX':
      return AmExCardIcon;

    case 'CASH':
      return CashPaymentIcon;

    case 'CHECK':
      return CheckPaymentIcon;

    case 'NEX':
      return GiftPaymentIcon;

    default:
      return CreditCardIcon;
  }
};

export const convertAurusCardType = (aurusCardType = '') => CFA_CARD_TYPES[aurusCardType] || aurusCardType;

export const convertToShortType = (networkType = '') => SHORT_CARD_TYPES[networkType.toUpperCase()] || networkType;

export const getUnexpiredCards = (assets) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  if (!assets) return [];

  return assets.filter((card) => {
    if (!card.expDate) {
      return true;
    }

    return new Date(card.expDate.replace(/-/g, '/')) >= today;
  });
};
